import type React from 'react'
import type { ITabContentProps } from '../interfaces'

const TabContent: React.FC<ITabContentProps> = () => null

export default TabContent
